import { useState } from "react";
import { X } from "lucide-react";
import METHOD_LOGO from "./MethodLogos";
import useTranslation from "../hooks/useTranslation";

export default function OvoPhoneModal({ isOpen, onClose, onSubmit, isProcessing }) {
  const { t } = useTranslation();
  const [phone, setPhone] = useState("");
  const [error, setError] = useState(null);

  const validateOvoPhone = (value) => {
    if (!value) return t("ovoPhoneModal.errorRequired");
    const digits = value.replace(/\D/g, "");
    if (!digits.startsWith("08")) return t("ovoPhoneModal.errorMustStart08");
    if (digits.length < 10) return t("ovoPhoneModal.errorMin10");
    if (digits.length > 15) return t("ovoPhoneModal.errorMax15");
    return null;
  };

  if (!isOpen) return null;

  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/[^\d]/g, "");
    if (value.startsWith("62") && !value.startsWith("0")) {
      value = "0" + value.substring(2);
    }
    setPhone(value);
    if (error) setError(null);
  };

  const handleSubmit = () => {
    const validationError = validateOvoPhone(phone);
    if (validationError) {
      setError(validationError);
      return;
    }
    onSubmit(phone);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSubmit();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-sm p-6 z-10">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <X size={20} />
        </button>

        <div className="flex flex-col items-center gap-3 mb-5">
          <img
            src={METHOD_LOGO.EWALLET_OVO}
            alt="OVO"
            className="h-10 object-contain"
          />
          <h3 className="text-lg font-bold text-gray-800">{t("ovoPhoneModal.title")}</h3>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t("ovoPhoneModal.phoneLabel")}
          </label>
          <input
            type="tel"
            inputMode="numeric"
            value={phone}
            onChange={handlePhoneChange}
            onKeyDown={handleKeyDown}
            placeholder={t("ovoPhoneModal.phonePlaceholder")}
            className={`w-full border rounded-lg p-3 text-base outline-none transition-colors ${
              error ? "border-red-400 focus:border-red-500" : "border-gray-300 focus:border-purple-500"
            }`}
            autoFocus
            disabled={isProcessing}
          />
          {error && (
            <p className="text-red-500 text-xs mt-1">{error}</p>
          )}
          <p className="text-gray-500 text-xs mt-1">{t("ovoPhoneModal.helper")}</p>
        </div>

        <button
          onClick={handleSubmit}
          disabled={isProcessing || !phone}
          className="w-full text-white font-bold py-3 px-6 rounded-xl transition-all disabled:opacity-50"
          style={{ backgroundColor: "#4C3494" }}
        >
          {isProcessing ? t("common.processing") : t("ovoPhoneModal.payNow")}
        </button>
      </div>
    </div>
  );
}
